export default __webpack_public_path__ + "static/media/rain-2.12d44ad7.png";